import { render } from "./DataResources.vue?vue&type=template&id=014fbd74"
import script from "./DataResources.vue?vue&type=script&lang=js"
export * from "./DataResources.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__